import { DuplicateBookingRecord } from "../interfaces/duplicateBookingsResponse.interface";

export interface IDuplicateBookingsState {
  duplicateBookings: DuplicateBookingRecord | null;
  isLoading: boolean;
  error: string | null;
}

const state: IDuplicateBookingsState = {
  duplicateBookings: null,
  isLoading: false,
  error: null,
};

export default state;
